import { INTERNSHIP_COMPLETED_STATUS, ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel , SmBtnMetaModel, SmMetaSelectModel} from "common/models/utility-models/meta-model";

export class MentorFeedbackMetaModel extends FormMetaModel {
    constructor() {
        super('Mentor Feedback', ROUTE_PATH.mentorFeedback, '', 2);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();

        const selectStudent = new SmMetaSelectModel(
            'selectStudent',
            'selectStudent',
            "select",
            true,
            "col-12 col-md-6 col-lg-6",
            1,
            1,
            'Student Name',
            "select",
            "",
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            "name",
            "id"
          );

        const selectStatus = new SmMetaSelectModel(
            'selectStatus',
            'selectStatus',
            "select",
            true,
            "col-12 col-md-6 col-lg-6",
            1,
            1,
            'Status',
            "select",
            "",
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            INTERNSHIP_COMPLETED_STATUS,
            "name",
            "id"
          );

        const buttons = {
            close: new SmBtnMetaModel('Submit', '', true, false, true, true,false),
            isFormControl: false
        };


        return {
            formInfo,
            buttons,
            selectStudent,
            selectStatus,
        };
    }
}